import React from "react";
import "./Alerts.css";
import { useSelector, useDispatch } from "react-redux";
import { markNotificationsRead } from "../redux/actions/currentProfileActions";
import { GoPerson, GoInfo } from "react-icons/go";
import { Link } from "react-router-dom";
import {
  IonContent,
  IonHeader,
  IonPage,
  useIonViewWillEnter,
} from "@ionic/react";
import Header from "../components/layout/Header";
import { Helmet } from "react-helmet-async";

function Alerts() {
  const notificationIconStyle = {
    width: "36px",
    minWidth: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.35rem",
    color: "#111",
  };

  const notificationTextStyle = {
    flex: 1,
    minWidth: 0,
    lineHeight: "1.45",
    fontSize: "1rem",
  };
  const { data } = useSelector((state) => state.currentProfile);
  const alerts = data.notifications;
  const dispatch = useDispatch();

  useIonViewWillEnter(() => {
    if (alerts && alerts.some((n) => !n.read)) {
      dispatch(markNotificationsRead());
    }
  }, [alerts, dispatch]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonHeader mode="ios">{/* <Header /> */}</IonHeader>
        <IonContent>
          {alerts
            ? alerts.map((notification, idx) => {
                if (notification.type === "follow") {
                  const username = notification.message.split(" ")[0];
                  const restOfMessage = notification.message
                    .replace(username, "")
                    .trim();
                  return (
                    <div
                      key={idx}
                      className="notification"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "18px 16px",
                        borderBottom: "1px solid #eee",
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    >
                      <div style={notificationIconStyle}>
                        <GoPerson />
                      </div>

                      <div style={notificationTextStyle}>
                        <Link
                          to={`/profile/${username}`}
                          style={{
                            color: "#d80621",
                            fontWeight: "bold",
                            textDecoration: "none",
                            marginRight: "4px",
                          }}
                        >
                          @{username}
                        </Link>
                        <span>{restOfMessage}</span>
                      </div>
                    </div>
                  );
                } else {
                  const content = (
                    <div
                      className="notification"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "18px 16px",
                        borderBottom: "1px solid #eee",
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    >
                      <div style={notificationIconStyle}>
                        <GoInfo />
                      </div>

                      <p
                        style={{
                          ...notificationTextStyle,
                          margin: 0,
                          color: "#111",
                        }}
                      >
                        {notification.message}
                      </p>
                    </div>
                  );

                  return notification.link ? (
                    <Link
                      to={notification.link}
                      key={idx}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {content}
                    </Link>
                  ) : (
                    <div key={idx}>{content}</div>
                  );
                }
              })
            : "loading.."}
        </IonContent>
      </IonPage>
    </>
  );
}

export default Alerts;
